import { render, staticRenderFns } from "./TeeamPcbCert.vue?vue&type=template&id=07f28e0e&scoped=true&lang=html&"
import script from "./TeeamPcbCert.vue?vue&type=script&lang=js&"
export * from "./TeeamPcbCert.vue?vue&type=script&lang=js&"
import style0 from "./TeeamPcbCert.vue?vue&type=style&index=0&id=07f28e0e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f28e0e",
  null
  
)

export default component.exports